// Statically analyzable URLs are emitted and base-rewritten by each independent Vite build.
export const ribbonLight = new URL("./assets/horizontal-light.svg", import.meta.url).href;
export const ribbonDark = new URL("./assets/horizontal-dark.svg", import.meta.url).href;
export const ribbonMarkDeep = new URL("./assets/mark-master-turquoise.svg", import.meta.url).href;
